<template>
  <div style="text-align: left">
    <el-form :inline="true" :model="formInline" class="demo-form-inline"  @keydown.native.enter="$emit('search', formInline)">
      <el-form-item label="店铺名称">
        <el-input
          v-model="formInline.customerShopName"
          placeholder="店铺名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="辅料商品SKU">
        <el-input
          v-model="formInline.shopProductSku"
          placeholder="辅料商品SKU"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          style="margin-left: 30px"
          type="primary"
          @click="$emit('search', formInline)"
          >搜索</el-button
        >
        <el-button style="margin-left: 10px" @click="rest">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Validator } from "@/utils/verification";
export default {
  name: "From",
  data() {
    return {
      formInline: {
        shopName: "",
        shopProductSku: "",
      },
    };
  },
  mounted() {
    this.$emit("search", this.formInline);
  },
  methods: {
    dateChange: function (date) {
      // console.log(val)
      if (!date) {
        this.formInline.shopName = null;
        this.formInline.shopProductSku = null;
        return;
      }
      this.$emit("search", this.formInline);
    },
    // upd(){
    //   let validator = new Validator();
    //   validator.
    //   validator.loopAdd(
    //     [
    //       this.formInline.shopName,
    //       this.formInline.shopProductSku,
    //     ],
    //     "isNoneEmpty",
    //     "请输入店铺名称和辅料SKU"
    //   );
    // },
    rest: function () {
      this.formInline = {
        shopName: "",
        shopProductSku: ""
      };
      this.$emit("search", this.formInline);
    },
  },
};
</script>

<style scoped></style>
